import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
    bbDoesCustomerHaveAccessToSubscriptionLevel,
    bbFindEntityWithinPortfolioOrSelf, bbFindHasEntityTagsById,
    bbFindUsersOnboardingProgress,
    bbFindUserTagsByTagId, bbIsEntityAwaitingFirstScoreCycle
} from "../../../util/bbHelpers";
import {Col, Row} from "reactstrap";
import {Button, CircularProgress, Paper, stepConnectorClasses, StepIcon, StepLabel, Stepper} from "@mui/material";
import {Badge, Box, Popper, Step, StepConnector, styled, withStyles} from "@material-ui/core";
import {Check} from "@material-ui/icons";
import BBIconCircleEmpty from "../../../assets/bbCustomIcons/BBIconCircleEmpty";
import {fetchRiskPortfolio, setCustomerInView} from "../../../actions";
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import BBIconCheckboxNo from "../../../assets/bbCustomIcons/BBIconCheckboxNo";
import BBIconCheckboxCheckedYes from "../../../assets/bbCustomIcons/BBIconCheckboxCheckedYes";
import BBIconCheckboxEmpty from "../../../assets/bbCustomIcons/BBIconCheckboxEmpty";

const CustomStepIcon = ({completed = false, active = false, })=>{
    return(
        <span className={"align-items-center m-0 p-0"}>
            {completed
            ? <BBIconCheckboxCheckedYes className={"m-0 p-0"} style={{
                color: `${active ? '#784af4' : '#bbb'}`,
                fontSize: "26px",
                }}/>
                : <BBIconCheckboxEmpty className={"m-0 p-0 align-items-center" }
                                     style={{
                                         color: `${active ? '#784af4' : '#bbb'}`,
                                         fontSize: "26px",
                                     }}
                />
            }
             {/*: <div style={{*/}
            {/*height: "12px",*/}
            {/*width: "12px",*/}
            {/*backgroundColor: `${active ? '#784af4' : '#bbb'}`,*/}
            {/*borderRadius: "50%",*/}
            {/*display: "inline-block",*/}
            {/*}}>&nbsp; </div>  }*/}
        </span>
    )
}


const OnboardingProgressDisplay = ({props})=> {

    const {authUser, } = useSelector(({auth})=> auth);
    const { updateEntityOnboardingProgress } =useSelector(({admin})=> admin);
    const { portfolios, entityInView, loadingPortfolios, selfEntityId} = useSelector(({breachrisk}) => breachrisk);
    const { didJustAddEntityTag } = useSelector(({breachrisk}) => breachrisk.appMisc);

    const {customers, customerInView, loadingCustomers} = useSelector(({customer})=> customer);

    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerInView);
    const customer = customers && customerInView && customers[customerInView] ? customers[customerInView] : null;

    const hasFreeSubscription = bbDoesCustomerHaveAccessToSubscriptionLevel(customer, 2, 10);
    const hasLiteSubscription = bbDoesCustomerHaveAccessToSubscriptionLevel(customer, 2, 6);
    const hasProSubscription = bbDoesCustomerHaveAccessToSubscriptionLevel(customer, 2, 7);
    const hasPremiumSubscription = bbDoesCustomerHaveAccessToSubscriptionLevel(customer, 2, 11);

    const dispatch = useDispatch();

    // console.log("onboarding items", userOnboardingProgress, completedOnboardingItems, totalOnboardingItems, "myEntity", myEntity)
    const userOnboardingProgress = bbFindUsersOnboardingProgress(myEntity, authUser);

    const completedOnboardingItems = userOnboardingProgress && userOnboardingProgress.filter(item => item.value === true).length;
    const totalOnboardingItems = userOnboardingProgress && userOnboardingProgress.length;
    const percentOnboardingComplete = userOnboardingProgress ? (completedOnboardingItems/totalOnboardingItems) * 100 : 0;
    // const percentOnboardingComplete = 100;

    const hasIpsNATag = bbFindHasEntityTagsById(myEntity, 71);
    const hasDomainsNATag = bbFindHasEntityTagsById(myEntity, 72);
    const hasIdentitiesNATag = bbFindHasEntityTagsById(myEntity, 74);
    const hasCloudNATag = bbFindHasEntityTagsById(myEntity, 73);

    useEffect(()=>{
        if(didJustAddEntityTag && didJustAddEntityTag[customerInView]){
            dispatch(fetchRiskPortfolio({
                customerId: customerInView
            }));
        }
    }, [didJustAddEntityTag])

    const indexOfFirstUnfinishedTask = userOnboardingProgress && percentOnboardingComplete !== 100
        ? userOnboardingProgress.findIndex(x=> !x.value)
        : null

    const [expanded, setExpanded] = useState(false);
    const [open, setOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [activeStep, setActiveStep] = useState(null);

    userOnboardingProgress && activeStep === null && (indexOfFirstUnfinishedTask !== null) && setActiveStep(indexOfFirstUnfinishedTask);

    const handleChange = () => {
        setExpanded(!expanded)
    };

    const handleMouseEnter = (event)=>{
        setOpen(true);
        setAnchorEl(event.currentTarget)
    }

    // console.log("onboarding items", userOnboardingProgress, completedOnboardingItems, totalOnboardingItems, "myEntity", myEntity)
    // console.log("This is the value for activeStep", activeStep, indexOfFirstUnfinishedTask)
    return(
        percentOnboardingComplete
        && percentOnboardingComplete !== 100
         ? <div className={"text-center"}>
                <Paper className={"jr-card jr-card-widget"}
                       style={{
                           minHeight: `${hasPremiumSubscription ? '600px' : '550px'}`,
                       }}>
                    <Row className={""}>
                        <Col>
                            <h2 className={"text-center"}>
                                Getting Started Checklist
                            </h2>
                            <br/>
                        </Col>
                    </Row>

                    <Row className={`p-2 text-center`} style={{position: 'relative', display: 'flex', alignItems: 'center'}}>
                        <Col sm={1} lg={1}/>
                        <Col>
                            {/*<Box sx={{ position: 'absolute',*/}
                            {/*    width: '100%',*/}
                            {/*    top: 50,*/}
                            {/*    left: 0,*/}
                            {/*    bottom: 0,*/}
                            {/*    right: 0,*/}
                            {/*    display: 'flex',*/}
                            {/*    alignItems: 'center',*/}
                            {/*    justifyContent: 'center',}}*/}
                            {/*>*/}
                            <Box sx={{ width: '100%',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}>
                                <LinearProgress
                                    variant="determinate"
                                    value={percentOnboardingComplete}
                                    // sx={{height: 10}}
                                    sx={{
                                        height: 22,
                                        borderRadius: 5,
                                        [`&.${linearProgressClasses.colorPrimary}`]: {
                                            backgroundColor: '#757575',
                                        },
                                        // [`&.${linearProgressClasses.colorPrimary}`]:{
                                        //     backgroundColor: #757575,},
                                        [`& .${linearProgressClasses.bar}`]: {
                                            borderRadius: 0,
                                            backgroundColor: '#0460D9',
                                        },
                                        display: "flex",
                                    }}
                                >
                                </LinearProgress>
                                {/*<CircularProgress*/}
                                {/*    variant="determinate"*/}
                                {/*    sx={{*/}
                                {/*        color: (theme) =>*/}
                                {/*            theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],*/}
                                {/*        position: 'absolute',*/}
                                {/*    }}*/}
                                {/*    size={150}*/}
                                {/*    thickness={6}*/}
                                {/*    value={100}*/}
                                {/*/>*/}
                                {/*<CircularProgress*/}
                                {/*    variant="determinate"*/}
                                {/*    size={150}*/}
                                {/*    thickness={6}*/}
                                {/*    sx={{*/}
                                {/*        position: 'absolute',*/}
                                {/*        color: '#0460D9',*/}
                                {/*    }}*/}
                                {/*    value={percentOnboardingComplete}*/}
                                {/*/>*/}
                            </Box>

                        </Col>
                        <Col sm={1} lg={1}/>

                    </Row>

                    <Row style={{marginTop: '-61px', color: "#f3f3f3",}}>
                        <Col>
                           {/*<h2>{customer && customer.CustomerName ? customer.CustomerName : "--"} </h2>*/}
                            <h2> </h2>
                            <br/>
                            <h2>
                                {`${Math.round(percentOnboardingComplete)}%`}
                                {/*{props.label ? props.label : null}*/}
                            </h2>
                        </Col>
                    </Row>

                    <div style={{position: "absolute", top: "30%", margin: '0', padding: '0', width: "90%"}}>
                        {/*<Col style={{ display: "flex", position: "absolute", top:`${expanded ? "35%" : ""}`, bottom: `${expanded ? "" : "0"}`, alignItems: 'center', justifyContent: "center"}} >*/}
                        {/*<Row className={'m-0 p-0 '} style={{width: "100%"}}>*/}
                        {/*    <Col lg={12} className={"text-left"}>*/}
                                {userOnboardingProgress && userOnboardingProgress.map((object, index)=>
                                    <span key={index}  onClick={()=>setActiveStep(index)}>
                                        <Row className={"m-0 p-0 "} style={{cursor: "pointer"}}>
                                            <Col className={"text-right m-0 p-0 align-self-center"} sm={1} lg={1}>
                                                <CustomStepIcon completed={object.value} active={activeStep === index}/>
                                            </Col>
                                            <Col className={` text-left ${activeStep === index ? "border-bottom border-dark" : ""} align-self-center`}>
                                                <p className={`${activeStep === index ? "text-decoration-underline" : ""} m-0 p-0`}
                                                   style={{
                                                           color: `${activeStep ===index ? '#784af4' : ''}`,}}>
                                                    {object.name.toUpperCase()}
                                                </p>
                                            </Col>
                                        </Row>
                                        <Row className={"m-0 p-0 text-left"} style={{minHeight: "10px"}}>
                                            <Col sm={1} lg={1} className={""}>
                                                {/*<div className={"align-self-center"} style={{background: "linear-gradient(#784af4, #784af4) no-repeat center/2px 100%"}}> </div>*/}
                                                {index !== userOnboardingProgress.length - 1
                                                 && <>
                                                    {/*<div className={""} style={{borderRight: "2px solid #784af4", height: "100%"}}> </div>*/}
                                                </>}
                                            </Col>
                                            <Col className={"m-1 "}>
                                                { activeStep === index
                                                    ? <>{object.description}</>
                                                    : null}
                                            </Col>
                                            {/*<Col sm={2}>*/}
                                            {/*    */}
                                            {/*</Col>*/}
                                        </Row>

                                    </span>
                                )}
                                {percentOnboardingComplete === 100 &&
                                <Row>
                                    <Col sm={1}>

                                    </Col>
                                    <Col>
                                        <p>
                                            ONBOARDING COMPLETE
                                        </p>
                                    </Col>
                                </Row>}

                        {/*    </Col>*/}
                        {/*</Row>*/}
                    </div>


                </Paper>
        </div>
            : null
    )
}

export default OnboardingProgressDisplay;